import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  "data-testid": "bulk-print-stt-max-hint",
  class: "text-gray-lp-500 pt-2"
}
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "pt-4 w-3/4 inline-block relative" }
const _hoisted_4 = {
  "data-testid": "bulk-print-stt-counter",
  class: "absolute right-0 bottom-0 mr-2 mb-2 text-gray-lp-600 text-12px xxl:text-14px"
}
const _hoisted_5 = {
  key: 0,
  "data-testid": "bulk-print-stt-duplicate-notice",
  class: "mt-4 w-3/4 rounded bg-orange-lp-100 px-3 py-2 text-orange-lp-300 text-12px xxl:text-14px"
}
const _hoisted_6 = {
  key: 1,
  "data-testid": "bulk-print-stt-limit-error",
  class: "mt-4 text-red-lp-100 text-12px xxl:text-14px"
}
const _hoisted_7 = { class: "pt-4 flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "border-t my-6 border-gray-lp-200" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "w-full text-20px h-screen"
}
const _hoisted_10 = { class: "flex flex-row justify-between pb-8" }
const _hoisted_11 = { class: "flex flex-row w-full justify-between divide-x divide-border-gray-lp-200" }
const _hoisted_12 = { class: "flex flex-row pt-2" }
const _hoisted_13 = { class: "flex flex-row pt-2" }
const _hoisted_14 = {
  class: "relative",
  "data-testid": "bulk-print-stt-table"
}
const _hoisted_15 = { class: "font-semibold text-14px text-gray-lp-300 absolute top-1 left-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Header = _resolveComponent("Header")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", {
    class: ["bg-white flex flex-col text-12px xxl:text-14px overflow-auto h-screen w-full", _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8']
  }, [
    _createVNode(_component_Breadcrumb),
    _createVNode(_component_Header, { currentRoutes: _ctx.getCurrentRoute }, null, 8, ["currentRoutes"]),
    _createVNode(_component_DataWrapper, {
      label: _ctx.$t('bulkPrintReceipt.listStt'),
      class: "w-full pt-6 text-12px xxl:text-14px"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("bulkPrintReceipt.maxStt", { maxStt: _ctx.maxSttInput })), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.setErrorList) + " " + _toDisplayString(_ctx.clearSttListValue()) + " ", 1),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_multiselect, {
              "data-testid": "bulk-print-stt-multiselect",
              class: "bulk-print-stt-multiselect",
              modelValue: _ctx.sttListValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttListValue = $event)),
              placeholder: _ctx.$t('bulkPrintReceipt.placeholder'),
              "tag-placeholder": "Press enter to add No. STT",
              label: "name",
              "track-by": "id",
              maxLength: _ctx.maxSttInput,
              options: _ctx.sttManualList,
              multiple: true,
              searchable: true,
              taggable: true,
              "preserve-search": true,
              allowMoreMax: true,
              "open-direction": "bottom",
              isTextArea: "",
              isError: _ctx.isError,
              autoDeduplicate: true,
              keepFocusAfterCommit: true,
              loading: _ctx.isLoadingSttManual,
              hasMore: _ctx.hasMoreSttManual,
              showEndOfList: true,
              endOfListText: _ctx.$t('bookingShipment.bulkPrint.allDataDisplayed'),
              inputTestId: "bulk-print-stt-input",
              optionsTestId: "bulk-print-stt-options",
              optionsLoadingTestId: "bulk-print-stt-options-loading",
              optionsEndTestId: "bulk-print-stt-options-end",
              onDuplicatesRemoved: _ctx.onDuplicatesRemoved,
              onLoadMore: _ctx.onLoadMoreStt,
              onSearchChange: _ctx.onSearch
            }, null, 8, ["modelValue", "placeholder", "maxLength", "options", "isError", "loading", "hasMore", "endOfListText", "onDuplicatesRemoved", "onLoadMore", "onSearchChange"]),
            _createVNode("div", _hoisted_4, _toDisplayString(_ctx.sttListValue.length) + "/" + _toDisplayString(_ctx.maxSttInput), 1)
          ]),
          (_ctx.duplicateRemovedCount > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("bulkPrintReceipt.duplicated", { removedCount: _ctx.duplicateRemovedCount })), 1))
            : _createCommentVNode("", true),
          (_ctx.isOverSttLimit)
            ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("bulkPrintReceipt.overlimitStt", { maxSttInput: _ctx.maxSttInput, excessSttCount: _ctx.excessSttCount })), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", { class: "mt-4 text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.errorMessageLength) + "/" + _toDisplayString(_ctx.sttListValue.length) + " " + _toDisplayString(_ctx.$t("bulkPrintReceipt.sttNotFound")), 513), [
            [_vShow, _ctx.hasSttLookupError]
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_button_fill, {
            custom: "bg-white px-12 border border-red-lp-100 text-white mr-4",
            title: _ctx.$t('bulkPrintReceipt.showStt'),
            isDisabled: _ctx.sttListValue.length === 0 || _ctx.isOverSttLimit,
            iconLeft: _ctx.isRefresh(),
            onClick: _ctx.onGenerate
          }, null, 8, ["title", "isDisabled", "iconLeft", "onClick"]),
          _withDirectives(_createVNode(_component_button_outline, {
            custom: "bg-white px-12 border border-red-lp-100 text-red-lp-200 mr-4",
            title: _ctx.$t('bulkPrintReceipt.deleteAll'),
            onClick: _ctx.deleteAll
          }, null, 8, ["title", "onClick"]), [
            [_vShow, _ctx.sttListValue.length !== 0]
          ])
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    _hoisted_8,
    (_ctx.isTableShow)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('bulkPrintReceipt.printReceipt'),
                class: "text-16px xxl:text-16px text-gray-lp-300 font-semibold w-full "
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_lp_button, {
                      "data-testid": "bulk-print-btn-resi-a6",
                      custom: 
                  `bg-white px-12 border mr-4 ${
                    _ctx.isRefresh()
                      ? 'border-gray-lp-500 text-gray-lp-500 cursor-not-allowed'
                      : 'border-red-lp-100 text-red-lp-200'
                  }`
                ,
                      iconLeft: "printer",
                      iconV2: true,
                      title: _ctx.$t('bulkPrintReceipt.printA6'),
                      color: "red-lp-300",
                      textColor: "white",
                      iconGroupHoverColor: "white",
                      customClass: "border border-red-lp-100",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printDoc('thermal-pdf'))),
                      disabled: !!_ctx.isRefresh()
                    }, null, 8, ["custom", "title", "disabled"]),
                    _createVNode(_component_lp_button, {
                      "data-testid": "bulk-print-btn-resi-a4",
                      custom: 
                  `bg-white px-12 border mr-4 ${
                    _ctx.isRefresh()
                      ? 'border-gray-lp-500 text-gray-lp-500 cursor-not-allowed'
                      : 'border-red-lp-100 text-red-lp-200'
                  }`
                ,
                      iconLeft: "printer",
                      iconV2: true,
                      title: _ctx.$t('bulkPrintReceipt.printA4'),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printDoc('basic'))),
                      color: "white",
                      textColor: "red-lp-300",
                      outline: "",
                      customClass: "border border-red-lp-100 ml-4",
                      disabled: !!_ctx.isRefresh()
                    }, null, 8, ["custom", "title", "disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: "Commercial Invoice Print",
                class: "pl-6 text-16px  xxl:text-16px text-gray-lp-300 font-semibold w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_lp_button, {
                      "data-testid": "bulk-print-btn-ci-a6",
                      custom: 
                  `bg-white px-12 border mr-4 ${
                    _ctx.isRefresh()
                      ? 'border-gray-lp-500 text-gray-lp-500 cursor-not-allowed'
                      : 'border-red-lp-100 text-red-lp-200'
                  }`
                ,
                      iconLeft: "printer",
                      iconV2: true,
                      title: _ctx.$t('bulkPrintReceipt.printA6'),
                      color: "red-lp-300",
                      textColor: "white",
                      iconGroupHoverColor: "white",
                      customClass: "border border-red-lp-100",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printComercialA6())),
                      disabled: !!_ctx.isRefresh() || !_ctx.hasInternationalCommercialInvoice
                    }, null, 8, ["custom", "title", "disabled"]),
                    _createVNode(_component_lp_button, {
                      "data-testid": "bulk-print-btn-ci-a4",
                      custom: 
                  `bg-white px-12 border mr-4 ${
                    _ctx.isRefresh()
                      ? 'border-gray-lp-500 text-gray-lp-500 cursor-not-allowed'
                      : 'border-red-lp-100 text-red-lp-200'
                  }`
                ,
                      iconLeft: "printer",
                      iconV2: true,
                      title: _ctx.$t('bulkPrintReceipt.printA4'),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printComercialA4())),
                      color: "white",
                      textColor: "red-lp-300",
                      outline: "",
                      customClass: "border border-red-lp-100 ml-4",
                      disabled: !!_ctx.isRefresh() || !_ctx.hasInternationalCommercialInvoice
                    }, null, 8, ["custom", "title", "disabled"])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("bulkPrintReceipt.showDetailStt", { count: _ctx.listData.length || 0 })), 1),
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.listData,
              isRightFreeze: "",
              totalColumnFreeze: 1,
              hidePagination: true,
              pagination: _ctx.pagination,
              borderTop: false,
              headerTextColor: "text-black-lp-200"
            }, null, 8, ["columns", "data", "pagination"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}